import styled, { css } from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import getBorderColor from "../../../../utils/getBorderColor";
import getBorderRadius from "../../../../utils/getBorderRadius";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import GridOrg from "../../GridOrg";
import PushOrg from "../../PushOrg";
import SurfaceOrg from "../../SurfaceOrg";
import { calculatorContainerMaxWidth } from "../MarketplaceCalculatorOrg.styled";
export var StyledResultBox = styled(SurfaceOrg).withConfig({
  componentId: "sc-1o3lhdv-0"
})(["display:flex;flex:1;flex-direction:column;flex-wrap:wrap;min-width:auto;", "{min-width:", ";@container (max-width:", "){min-width:auto;}}"], breakpoint("medium"), unit(424), unit(calculatorContainerMaxWidth));
export var StyledResultBoxContent = styled.div.withConfig({
  componentId: "sc-1o3lhdv-1"
})(["@container (max-width:", "){", "{display:flex;flex-direction:row;}}"], unit(calculatorContainerMaxWidth), breakpoint("huge"));
export var StyledParamsBox = styled(GridOrg).withConfig({
  componentId: "sc-1o3lhdv-2"
})(["@container (max-width:", "){grid-template-columns:repeat(1,1fr);}"], unit(calculatorContainerMaxWidth));
export var StyledInfoBox = styled(PushOrg).withConfig({
  componentId: "sc-1o3lhdv-3"
})(["min-width:", ";@container (max-width:", "){display:flex;flex:1;flex-direction:column;}", "{margin-bottom:0;}"], unit(220), unit(calculatorContainerMaxWidth), breakpoint("small", "medium"));
export var StyledPriceBox = styled.div.withConfig({
  componentId: "sc-1o3lhdv-4"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["min-width:", ";padding:", ";border:", " solid ", ";border-radius:", ";"], unit(220), space(2), unit(1), getBorderColor(theme, "backgroundLight", "extraLow"), getBorderRadius(theme, "large2"));
});
export var StyledParamValue = styled.div.withConfig({
  componentId: "sc-1o3lhdv-5"
})(["@container (max-width:", "){margin-left:", ";}", "{margin-left:", ";}"], unit(calculatorContainerMaxWidth), space(3), breakpoint("small", "medium"), space(3));